import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameConfig} from "../../DevilsCrossRoadGameConfig";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";


export class DevilsCrossroadFreespinZeroBet implements FlowStatePresentation {
    private stepIndex:number = 0;


    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        const tl:gsap.core.Timeline = gsap.timeline();

        const stepSizes = [
            {x:DevilsCrossRoadGameConfig.freespinStepSize.x , y:DevilsCrossRoadGameConfig.freespinStepSize.y}
        ]

        tl.add(DevilsCrossRoad.freespinUnlockAreas.resetFeatureAnimations());

        const spinTl = gsap.timeline();

        /*DevilsCrossRoad.freespinReelAreaView.reels[i][j].forEach((reel) => {
            if(reel.model) {

            }
        });*/

        for (let i:number = 0; i < DevilsCrossRoad.freespinReelAreaView.reels.length; i++) {
            for (let j:number = 0; j < DevilsCrossRoad.freespinReelAreaView.reels[i].length; j++) {
                DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.stepSize = stepSizes[this.stepIndex];
                //if (DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.active){
                    spinTl.add(DevilsCrossRoad.freespinReelAreaView.reels[i][j].model.start(false), "<0.01");
                //}
            }
        }
        this.stepIndex++;
        this.stepIndex %= stepSizes.length;

        tl.add(spinTl);
        tl.add(()=>{
            if (!DevilsCrossRoad.model.data.fullScreenCoin) {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_REEL_SPIN_START});
            }
        }, "<0.8");
        tl.add(() => {
            if (!DevilsCrossRoad.model.data.fullScreenCoin) {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_REEL_SPIN_LOOP})?.setLoop(true);
            }
        }, "<");
        tl.add(()=>{flowStateController.finish()});
    }

}